import React from 'react';
import RightSideMenu from './RightSideMenu';
import { ArrowRightIcon } from './Icons';
import MegaMenuItem from './MegaMenuItem';
import useVisitorLocation from '../hooks/useVisitorLocation';
import { appendTrackingParams } from '../utils/tracking';
import '../css/megamenu.css';

const Navbar = () => {
  const { flag, countryName } = useVisitorLocation();

  return (

<nav className="navbar navbar-expand-lg navbar-light gf-header-menu worldwide11">
      <div className="container-fluid ps-3 pe-3 ps-md-5 pe-md-5">
        <a className="navbar-brand" href="/"><img src='/assets/images/GF-logo.svg' className="header-site-logo" alt="logo"/></a>
        <button className="navbar-toggler hide-in-mobile" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse hide-in-mobile" id="navbarNav">
          <ul className="navbar-nav hide-in-mobile gf-mega-nav">

            <MegaMenuItem label="For Personal">
              <div className="gf-mega-flat-list">
                <a href="/personal/virtual-personal-assistant" style={{ fontWeight: 700 }}>For Personal</a>
                <a href="/personal/family-and-personal">Family & Personal</a>
                <a href="/personal/travel-management">Travel Management</a>
                <a href="/personal/online-research">Online Research</a>
                <a href="/personal/remote-executive-secretary">Remote Personal Assistant</a>
                <a href="/personal/sundry-tasks">Sundry Tasks</a>
                <a href="/personal/ai-guidance">AI For Personal Life</a>
              </div>
            </MegaMenuItem>

            <MegaMenuItem label="For Business">
              <div className="gf-mega-flat-list">
                <a href="/business/services" style={{ fontWeight: 700 }}>For Business</a>
                <a href="/business/business-process-support">Business Process Support</a>
                <a href="/business/research-analytics">Research & Analytics</a>
                <a href="/business/remote-executive-secretary">Remote Executive Secretary</a>
                <a href="/business/website-services">Website & App Development</a>
                <a href="/business/digital-marketing">SEO/Digital Marketing</a>
                <a href="/business/odoo-implementation">Odoo Implementation</a>
                <a href="/business/bookkeeping-service">Bookkeeping Services</a>
                <a href="/business/bookkeeping-service/quickbooks-bookkeeping">QuickBooks Bookkeeping</a>
                <a href="/business/ai-automation">AI Automation & Integration</a>
                <a href="/business/vacation-rental">Vacation Rental</a>
              </div>
            </MegaMenuItem>

            <MegaMenuItem label="Industries">
              <div className="gf-mega-flat-list">
                <a href="/industries" style={{ fontWeight: 700 }}>All Industries</a>
                <a href="/industries/real-estate">Real Estate</a>
                <a href="/industries/ecommerce">Ecommerce</a>
                <a href="/industries/property-management">Property Management</a>
                <a href="/industries/legal-services">Legal Services</a>
                <a href="/industries/consulting">Consulting</a>
                <a href="/industries/small-business">Small Business</a>
                <a href="/industries/startups-entrepreneurs">Startups &amp; Entrepreneurs</a>
                <a href="/industries/nonprofit-organizations">Nonprofit Organizations</a>
                <a href="/industries/vacation-rentals">Vacation Rentals</a>
                <a href="/industries/accounting-bookkeeping">Accounting &amp; Bookkeeping</a>
                <a href="/industries/coaching-training">Coaching &amp; Training</a>
                <a href="/industries/digital-marketing-agencies">Digital Marketing Agencies</a>
                <a href="/industries/education-edtech">Education &amp; EdTech</a>
                <a href="/industries/financial-advisory">Financial Advisory</a>
                <a href="/industries/healthcare">Healthcare</a>
                <a href="/industries/hospitality">Hospitality</a>
                <a href="/industries/podcasting-content-creation">Podcasting &amp; Content Creation</a>
                <a href="/industries/recruitment-staffing">Recruitment &amp; Staffing</a>
              </div>
            </MegaMenuItem>

            <li className="nav-item">
              <a className="nav-link" href="/how-we-work">
                  How it works
                </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/personal/pricing-plans">
                  Pricing
                </a>
            </li>
          </ul>
        </div>
       <div className="header-right-group">
         <a className="nav-link btn header-menu-btn gf-btn me-3 hide-in-mobile" href="/contact-us">
                  <span className="d-flex align-content-center">Contact Us <ArrowRightIcon className="ms-1" /></span>
          </a>
          <a className="nav-link btn header-menu-btn gf-btn me-3 hide-in-mobile" href={appendTrackingParams("https://myaccount.getfriday.com/web/signup")} target="_blank" rel="noopener noreferrer">
                  <span className="d-flex align-content-center">Hire Now <ArrowRightIcon className="ms-1" /></span>
          </a>
          <img src={flag} alt={countryName || 'country flag'} height="20px" width="30px" className="header-country-flag me-3 hide-in-mobile"></img>
          <RightSideMenu/>
       </div>
      </div>
    </nav>
  );
};

export default Navbar;
